import Vue from 'vue'
import VueRouter from 'vue-router'
import CashierView from '../views/CashierView.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/', name: 'cashier', component: CashierView },
    { path: '/pay', redirect: '/' }
  ]
})
